// Module
var code = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path id=\"Icon_ionic-md-home\" data-name=\"Icon ionic-md-home\" d=\"M9.231,24V16h5.538v8H20.4V12H24L12,0,0,12H3.6V24Z\"/></svg>";
// Exports
module.exports = code;